import { SWAN_STYLE_KEY_MAP } from '@vp/swan';

export const FinishingOptionsSwanStylesKeys = [
  SWAN_STYLE_KEY_MAP.core,
  SWAN_STYLE_KEY_MAP.alertBox,
  SWAN_STYLE_KEY_MAP.standardTile,
];
